<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g>
    <rect width="64" height="64" fill="none"/>
    <g>
      <path class="filled" d="M41.516,55.454H22.484a3.556,3.556,0,0,1-3.541-3.217L16.154,23.19A.846.846,0,0,1,17,22.263H47a.846.846,0,0,1,.842.927L45.057,52.237A3.556,3.556,0,0,1,41.516,55.454Z" fill="currentColor"/>
      <path class="filled" d="M37.678,11.983V9.073A1.528,1.528,0,0,0,36.15,7.546h-8.3a1.528,1.528,0,0,0-1.528,1.527v2.91H15.9a1.528,1.528,0,0,0-1.528,1.527v2.806A1.528,1.528,0,0,0,15.9,17.844H48.1a1.528,1.528,0,0,0,1.528-1.528V13.51A1.528,1.528,0,0,0,48.1,11.983Z" fill="currentColor"/>
    </g>
  </g>
</svg>
